// src/components/FlipbookViewer.js
import './FlipBook.css';

export default function FlipbookViewer() {
  return (
    <div className="flipbook-container">
      <h2 className="flipbook-title">Sample Photobook Preview</h2>
      <div className="flipbook-frame-wrapper">
        <iframe
          title="Photobook Flip Viewer"
          src="https://online.fliphtml5.com/cijoy/jhsi/?code=cholanAA"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}
